module.exports = __webpack_public_path__ + "img/党员的权利.78de9062.png";